import { UseFormSetValue } from "react-hook-form";
import {
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  Radio,
  Typography,
  Box,
} from "@mui/material";

import { MdCheck, MdClear } from "react-icons/md";
import { useContext } from "react";
import { MainContext } from "../../../main/context/MainContextProvider";
import CardBox from "../../../main/components/CardBox";
export type PlanResources = {
  id: string;
  name: string;
  starter: boolean | string;
  plus: boolean | string;
  premium: boolean | string;
  ultimate: boolean | string;
  highlight: boolean;
};
export default function PlanSelectTable(props: {
  setValue: UseFormSetValue<any>;
  selectedPlan: string;
}) {
  const { setValue, selectedPlan } = props;
  const plansResources: PlanResources[] = [
    {
      id: "1",
      name: "Monitoramento remoto - ROP",
      starter: true,
      plus: true,
      premium: true,
      ultimate: true,
      highlight: false,
    },
    {
      id: "2",
      name: "Relatórios de falha e produção",
      starter: true,
      plus: true,
      premium: true,
      ultimate: true,
      highlight: false,
    },
    {
      id: "3",
      name: "Gestão de garantias e sobressalentes",
      starter: false,
      plus: true,
      premium: true,
      ultimate: true,
      highlight: false,
    },
    {
      id: "4",
      name: "Planejamento e Controle da Manutenção",
      starter: false,
      plus: true,
      premium: true,
      ultimate: true,
      highlight: false,
    },
    {
      id: "5",
      name: "Preditivas Anuais - Gestão",
      starter: false,
      plus: true,
      premium: true,
      ultimate: true,
      highlight: false,
    },
    {
      id: "6",
      name: "Preditivas Anuais - Execução",
      starter: false,
      plus: false,
      premium: true,
      ultimate: true,
      highlight: false,
    },
    {
      id: "7",
      name: "Operação Local",
      starter: false,
      plus: false,
      premium: true,
      ultimate: true,
      highlight: false,
    },
    {
      id: "8",
      name: "Garantia de Disponibilidade",
      starter: false,
      plus: false,
      premium: false,
      ultimate: "96%",
      highlight: false,
    },
    {
      id: "9",
      name: "Inspeção Termográfica - Anual",
      starter: false,
      plus: false,
      premium: false,
      ultimate: true,
      highlight: true,
    },
    {
      id: "10",
      name: "Roçagem - Anual",
      starter: false,
      plus: false,
      premium: false,
      ultimate: true,
      highlight: true,
    },
    {
      id: "11",
      name: "Limpeza de módulos - Semestral",
      starter: false,
      plus: false,
      premium: false,
      ultimate: true,
      highlight: true,
    },
    {
      id: "12",
      name: "Visitas Técnicas",
      starter: false,
      plus: false,
      premium: false,
      ultimate: false,
      highlight: true,
    },
    {
      id: "13",
      name: "Visitas - Engenharia",
      starter: false,
      plus: false,
      premium: false,
      ultimate: false,
      highlight: true,
    },
  ];
  const plans = [
    {
      id: "6570cddd0f36f7728d1f07ce",
      name: "Starter",
    },
    {
      id: "6570ce42a8b5d0d19462bec6",
      name: "Plus",
    },
    {
      id: "6570cf1633d8392b09361ca5",
      name: "Premium",
    },
    {
      id: "6570cf1c7b59e00b041e0dc5",
      name: "Ultimate",
    },
  ];
  const { theme } = useContext(MainContext);
  const primaryColor = theme.muiTheme.palette.primary.main;
  return (
    <CardBox sx={{ width: "100%" }}>
      <TableContainer
        sx={{
          width: "100%",
          overflow: "auto",

          paddingTop: "20px",
        }}
      >
        <Table size="small" stickyHeader>
          <TableBody>
            <TableRow
              sx={{
                "& th": {
                  backgroundColor: "#FBFCFD",
                  border: "none",
                },
              }}
            >
              <TableCell align="center"></TableCell>
              {plans.map((plan) => {
                return (
                  <TableCell
                    key={plan.id}
                    align="center"
                    sx={{ display: "", justifyContent: "" }}
                  >
                    <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                      {plan.name}
                    </Typography>
                    <Radio
                      checked={selectedPlan === plan.id}
                      onChange={(_, checked) => {
                        if (checked) setValue("selectedPlanId", plan.id);
                        else setValue("selectedPlanId", "");
                      }}
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  </TableCell>
                );
              })}
            </TableRow>
            {plansResources.map((resources) => {
              return (
                <TableRow hover key={resources.id}>
                  <TableCell
                    sx={{
                      backgroundColor: resources.highlight ? primaryColor : "",
                    }}
                  >
                    {resources.name}
                  </TableCell>
                  <PlanSelectTableCell
                    resource={resources.starter}
                    highlight={resources.highlight}
                    primaryColor={primaryColor}
                  />
                  <PlanSelectTableCell
                    resource={resources.plus}
                    highlight={resources.highlight}
                    primaryColor={primaryColor}
                  />
                  <PlanSelectTableCell
                    resource={resources.premium}
                    highlight={resources.highlight}
                    primaryColor={primaryColor}
                  />
                  <PlanSelectTableCell
                    resource={resources.ultimate}
                    highlight={resources.highlight}
                    primaryColor={primaryColor}
                  />
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </CardBox>
  );
}

function PlanSelectTableIcon(props: { included: boolean }) {
  const { included } = props;
  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          backgroundColor: included
            ? "rgba(56, 125, 39, 1)"
            : "rgba(209, 56, 46, 1)",
          borderRadius: "50px",
          height: "20px",
          width: "20px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {included ? (
          <MdCheck
            style={{
              width: "13px",
              height: "13px",
              color: "white",
            }}
          />
        ) : (
          <MdClear
            style={{
              width: "13px",
              height: "13px",
              color: "white",
            }}
          />
        )}
      </Box>
    </Box>
  );
}
function PlanSelectTableCell(props: {
  resource: boolean | string;
  highlight?: boolean;
  primaryColor: string;
}) {
  const { resource, highlight, primaryColor } = props;
  return (
    <TableCell
      sx={{
        backgroundColor: highlight ? primaryColor : "",
      }}
      align="center"
    >
      {resource === false || resource === true ? (
        <PlanSelectTableIcon included={resource} />
      ) : (
        resource
      )}
    </TableCell>
  );
}
